<template>
    <div class="map-option">
        <div v-for="item of data" :key="item.key" class="option">
            <img :src="item.image" class="option--image" />
            <div class="option__value">
                <p>{{ item.value }}</p>
                <p>
                    <span>{{ item.name }}</span
                    ><span>({{ item.unit }})</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import * as largeScreenAPI from '@/api/large-screen'
import { handleData, mergeArrayValue } from '@/utils/index'

const nameList = ['机耕', '机插', '机防', '机收', '机烘']

export default {
    data() {
        return {
            data: []
        }
    },
    methods: {
        async getJobMachineryCount() {
            const currScreenType = JSON.parse(
                sessionStorage.getItem('currScreenType')
            )
            const response = await largeScreenAPI.getJobMachineryCount(
                currScreenType.locId
            )
            if (response.data.length) {
                this.data = handleData(response.data)
                this.data.forEach((item, index) => {
                    item.name = nameList[index]
                    item.unit = '台'
                    item.image = require(`../../../assets/images/map-option-${
                        item.key.split('Sum')[0]
                    }.png`)
                })
                this.data.unshift({
                    key: 'total',
                    name: '农机总数',
                    unit: '台',
                    value: mergeArrayValue(this.data),
                    image: require(`../../../assets/images/map-option-total.png`)
                })
            }
        }
    },
    mounted() {
        this.getJobMachineryCount()
    }
}
</script>
<style lang="scss" scoped>
.map-option {
    width: 264px;
    height: calc(100% - 21px);
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 1px;
    position: absolute;
    left: 0;
    z-index: 400;
    padding-top: 20px;
    box-sizing: border-box;
    .option {
        display: flex;
        align-items: center;
        height: 130px;
        position: relative;
        &::before {
            content: '';
            width: 100%;
            height: 1px;
            background-image: linear-gradient(
                to right,
                rgba(39, 164, 238, 0.1),
                rgba(39, 164, 238, 1),
                rgba(39, 164, 238, 0.1)
            );
            position: absolute;
            bottom: 0;
        }
        &--image {
            width: 110px;
            height: 110px;
        }
        &__value {
            p {
                margin: 0;
                &:first-child {
                    font-size: 28px;
                    color: #00bcfc;
                    font-weight: 700;
                    margin-bottom: 6px;
                    background-image: -webkit-gradient(
                        linear,
                        0 0,
                        0 bottom,
                        from(#2be5ff),
                        to(#00a3d9)
                    );
                    background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                &:last-child {
                    font-size: 18px;
                    color: #fff;
                    span {
                        &:last-child {
                            color: #a3a3a3;
                            margin-left: 5px;
                        }
                    }
                }
            }
        }
    }
}
</style>
